import React from 'react';
import { instanceOf } from 'prop-types';

import { connect } from 'react-redux';
import IESurveyList from '../IESurveyList';
import IELoading from '../IELoading';
import IEErrorMessage from '../IEErrorMessage';

const SurveyList = ({ ieSurveyList, ieStudies }) => {
  if (ieSurveyList.loading) {
    return <IELoading />;
  }

  if (ieSurveyList.error) {
    return <IEErrorMessage message="Something went wrong, please try again later." />;
  }

  return (
    <div className="ie--list">
      <div className="ie--container">
        <IESurveyList
          surveyList={ieSurveyList.data}
          studies={ieStudies}
          isQtsEnabled
        />
      </div>
    </div>
  );
};

SurveyList.propTypes = {
  ieStudies: instanceOf(Array),
  ieSurveyList: instanceOf(Object),
};

SurveyList.defaultProps = {
  ieStudies: [],
  ieSurveyList: {
    loading: false,
    error: false,
    data: [],
  },
};

const mapStateToProps = ({ turnkeyOmnibus }) => ({
  ieSurveyList: turnkeyOmnibus.ieSurveyList,
  ieStudies: turnkeyOmnibus.ieStudy.data,
});

export default connect(
  mapStateToProps,
  null
)(SurveyList);
